import React from 'react';

export default function SkeletonLoader() {
    return (
        <div style={{padding: '40px', maxWidth: '1000px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '30px' }}>
            <style>{`
                @keyframes shimmer { 
                    0% { opacity: 0.3; } 
                    50% { opacity: 0.8; } 
                    100% { opacity: 0.3; } 
                }
            `}</style>
            
            {/* Header Skeleton */}
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '20px', gap: '10px' }}>
                <div style={{width: '80px', height: '80px', background: 'var(--bg-primary)', borderRadius: '50%', animation: 'shimmer 1.5s infinite' }}></div>
                <div style={{width: '200px', height: '25px', background: 'var(--bg-primary)', borderRadius: '8px', animation: 'shimmer 1.5s infinite' }}></div>
                <div style={{width: '150px', height: '15px', background: 'var(--bg-primary)', borderRadius: '8px', animation: 'shimmer 1.5s infinite' }}></div>
            </div>
            
            {/* Tabs Skeleton */}
            <div style={{display: 'flex', gap: '10px', overflowX: 'hidden', paddingBottom: '10px' }}>
                {[1, 2, 3, 4, 5].map(i => (
                    <div key={i} style={{width: '130px', height: '45px', background: 'var(--bg-primary)', borderRadius: '8px', animation: 'shimmer 1.5s infinite' }}></div>
                ))}
            </div>
            
            {/* Main Content Box Skeleton */}
            <div style={{width: '100%', height: '400px', background: 'var(--bg-primary)', borderRadius: '16px', animation: 'shimmer 1.5s infinite' }}></div>
        </div>
    );
}
